export default __webpack_public_path__ + "static/wso2-8fa6ef0d07f115142e6a06bc74e822a8.png";